export const widgetView = {
  id: null,
  name: null,
  order: null,
  widgets: [],
};
